import { MACCreditCardAction, MACCreditCardState } from '../models';
import { ENABLE_AUTO_RENEW, UPDATE_CC_DETAILS } from '../actions/creditCard';
import Progress from 'redux-progress';

export const initialState: MACCreditCardState = {
  ccDetails: {},
  enableAutoRenew: Progress.none,
};

export default (
  state: MACCreditCardState = initialState,
  action: MACCreditCardAction,
): MACCreditCardState => {
  switch (action.type) {
    case UPDATE_CC_DETAILS: {
      return {
        ...state,
        ccDetails: { ...state.ccDetails, [action.id]: action.progress },
      };
    }
    case ENABLE_AUTO_RENEW: {
      return {
        ...state,
        enableAutoRenew: action.progress,
      };
    }
    default: {
      return state;
    }
  }
};
